import { render } from "./SuppliersTable.vue?vue&type=template&id=80a7530e&scoped=true"
import script from "./SuppliersTable.vue?vue&type=script&lang=js"
export * from "./SuppliersTable.vue?vue&type=script&lang=js"

import "./SuppliersTable.vue?vue&type=style&index=0&id=80a7530e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80a7530e"]])

export default __exports__